<template>
    <div class="clients">
      <div class="pageContent">
        <heading-wrap>
           <span slot="title">Clients</span>
           <span slot="link">
            <router-link v-if="isAdmin" class="btn btn-primary pull-right" :to="{ path: `client/add` }">
              Add Client
            </router-link>
           </span>
        </heading-wrap>

        <spinner v-if="loading" />

        <search-box v-model="search" name="clients..." />

        <slot-table :data="filteredClients" :columns="table.columns">

          <template slot="name" slot-scope="props">
            <router-link :to="{ path: `client/${props.item.hash_id}` }">
                <span class="clients__logo">
                  <client-logo v-if="props.item.logo" type="small" :path="props.item.logo"/>
                  <span>{{ props.item.name }}</span>
                </span>
            </router-link>
          </template>

          <template slot="date_created" slot-scope="props">
            <span>{{props.item.date_created.value | formatDate("YYYY") }}</span>
          </template>

          <template slot="clientsActions" slot-scope="props">
            <span v-if="props.item.clientsActions && isAdmin">
              <router-link class="btn btn-warning btn-xs" :to="{ path: `client/${props.item.hash_id}/edit` }">
                  <i class="fa fa-pencil" aria-hidden="true"></i>
              </router-link>
              <button-cta title="confirm" data-modalType="deleteClient" :data-modalID="props.item.hash_id" :data-modalField="props.item.name" :onClick="onLaunchModal" class="btn btn-danger btn-xs">
                <i class="fa fa-trash" aria-hidden="true"></i>
              </button-cta>
            </span>
          </template>
        </slot-table>
      </div>
        <portal to="globalModal">
          <modal-client-confirm :show="showModal.deleteClient" :confirmId="modalId" :field="modalField" @close="toggleModal('deleteClient')" />
        </portal>

    </div>
</template>

<script>
import HeadingWrap from '@/components/HeadingWrap/heading-wrap'
import ButtonCta from '@/components/Button/button'
import SlotTable from '@/components/Table/table'
import ClientLogo from '@/components/ClientLogo/client-logo'
import {clientMixin} from '@/mixins/clientMixin'
import {modalMixin} from '@/mixins/modalMixin'
import {notificationMixin} from '@/mixins/notificationMixin'
import Spinner from '@/components/SpinnerIcon/spinner'
import SearchBox from '@/components/SearchBox/searchbox'
import ModalClientConfirm from '@/components/Modal/clients/modal-client-confirm'

import { assoc, map } from 'ramda'

export default {
  name: 'Clients',
  mixins: [clientMixin, modalMixin, notificationMixin],
  props: {
    isAdmin: Boolean
  },
  components: {
    HeadingWrap,
    ButtonCta,
    SlotTable,
    Spinner,
    ClientLogo,
    SearchBox,
    ModalClientConfirm
  },
  data: () => ({
    // loading: true,
    search: '',
    rowActive: false,
    deleteId: null,
    table: {
      columns: {
        name: 'Client',
        user_count: 'User Count',
        campaigns: 'Campaign Count',
        date_created: 'Date Created',
        clientsActions: ''
      }
    }
  }),
  created () {
    this.startLoading()
    this.getClients().then(() => {
      this.finishLoading()
    }, error => {
      this.finishLoading()
      this.addNotification('danger', error)
    })
  },
  computed: {
    formattedClients () {
      // add clientActions key/value to data
      return map(item => assoc('clientsActions', true, item), this.clients)
    },
    filteredClients () {
      return this.formattedClients.filter(client => {
        return client.name.toLowerCase().includes(this.search.toLowerCase())
      })
    }
  },
  methods: {
    onRowMouseOver (event) {
      event.currentTarget.classList.add('clients--active')
    }
  }
}

</script>

<style lang="scss">
  .clients {
    &__logo {
      display: flex;
      align-items: center;
      .clientLogo {
        margin-right: 10px;
      }

    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/client/clients.vue